import React from "react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="max-w-4xl w-full bg-black/20 backdrop-blur-sm rounded-lg p-8 border border-gray-600/30">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-white mb-4 bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
          Terms of Service
        </h1>
        <p className="text-gray-300">Last updated: September 2025</p>
      </div>

      <div className="space-y-6 text-gray-300">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Acceptance of Terms
          </h2>
          <p>
            By accessing and using Max Winz Ferda Kids website and services, you
            accept and agree to be bound by the terms and provision of this
            agreement.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Use License</h2>
          <p className="mb-3">
            Permission is granted to temporarily use our services for:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Making donations to support children with cancer</li>
            <li>Submitting help requests for medical assistance</li>
            <li>Learning about our charitable programs</li>
            <li>Contacting us for support and information</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Donations</h2>
          <p className="mb-3">When making donations through our platform:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>All donations are final and non-refundable</li>
            <li>
              Donations are used to support children with cancer and their
              families
            </li>
            <li>We provide receipts for tax-deductible donations</li>
            <li>
              We reserve the right to refuse donations that violate our mission
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Help Requests
          </h2>
          <p className="mb-3">When submitting help requests:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>All information must be accurate and truthful</li>
            <li>We review all requests but cannot guarantee assistance</li>
            <li>Decisions are made based on available resources and need</li>
            <li>We may request additional documentation to verify need</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Prohibited Uses
          </h2>
          <p className="mb-3">You may not use our services:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              For any unlawful purpose or to solicit others to perform unlawful
              acts
            </li>
            <li>
              To violate any international, federal, provincial, or state
              regulations, rules, laws, or local ordinances
            </li>
            <li>
              To infringe upon or violate our intellectual property rights or
              the intellectual property rights of others
            </li>
            <li>
              To harass, abuse, insult, harm, defame, slander, disparage,
              intimidate, or discriminate
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">Disclaimer</h2>
          <p>
            The information on this website is provided on an "as is" basis. To
            the fullest extent permitted by law, Max Winz Ferda Kids excludes
            all representations, warranties, conditions and terms relating to
            our website and the use of this website.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Limitation of Liability
          </h2>
          <p>
            In no event shall Max Winz Ferda Kids, nor its directors, employees,
            partners, agents, suppliers, or affiliates, be liable for any
            indirect, incidental, special, consequential, or punitive damages
            arising out of your use of our services.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">
            Contact Information
          </h2>
          <p>
            If you have any questions about these Terms of Service, please
            contact us at:
          </p>
          <p className="mt-2 text-blue-400">contact@maxwinsferdakids.org</p>
        </section>
      </div>

      <div className="text-center mt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-8 py-3 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-lg hover:shadow-purple-500/25"
        >
          <span>🏠</span>
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default TermsOfService;
